<div class="container">
  <img class="image" [src]="space.thumb" />
  <div class="content">
    <h2 class="title">{{ space.name }}</h2>
    <div class="list-element">
      <span class="message">{{
        "coworking-home.spaces.quantity" | translate
      }}</span>
      <span class="number">{{ space.quantity }}</span>
    </div>
    <div class="list-element">
      <span class="message">{{
        "coworking-home.spaces.occuped" | translate
      }}</span>
      <span class="number">{{ space.occupied }}</span>
    </div>
    <div class="list-element">
      <span class="message">{{
        "coworking-home.spaces.free" | translate
      }}</span>
      <span class="number">{{ space.available }}</span>
    </div>
    <div class="button-wrapper">
      <button [ngClass]="{ pause: space.status === 1 }" (click)="onPause()">
        <img [src]="getPauseIcon" />
        <span *ngIf="space.status === 0">{{
          "coworking-home.spaces.reactivate" | translate
        }}</span>
        <span *ngIf="space.status === 1">{{
          "coworking-home.spaces.pause" | translate
        }}</span>
      </button>
    </div>
  </div>
</div>
